// This file is generated by a script and should not be modified directly.
const markdown: string =
  "- `null` lorsque le champs `identifiant.cfd` est `null`.\n- Le code NSF est déduis du code formation diplôme (CFD), il n'inclut donc pas la lettre de spécialité et le tableau ne contient qu'un seul élément.\n"
export default markdown
